import * as React from "react";
import { useCallback, useState } from "react";
import styled from "styled-components";
import { useBulkSetStatusForSecurityEvents } from "security-app/hooks/useSecurityEventsAPI";
import { ConfirmDialog } from "security-app/components/common/Modal";
import SetStatusControl from "security-app/components/SecurityEvents/Alerts/EventDetails/SetStatusControl";
import HelpBlock from "components/bootstrap/HelpBlock";
import Alert from "components/bootstrap/Alert";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
import useRefetchTable from "security-app/components/SecurityEvents/Alerts/AlertsModals/UsersModal/useRefetchTable";
import useDeselectEntities from "common/hooks/useDeselectEntities";
const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;
`;
const StyledHelpBlock = styled(HelpBlock)`
  margin: 2px 0;
`;
const SetStatusModal = ({
  onConfirm,
  show,
  confirmDisabled,
  onClose,
  isError,
  error,
  isLoading
}) => {
  const [newStatus, setNewStatus] = useState(void 0);
  const _onConfirm = useCallback(() => onConfirm(newStatus), [newStatus, onConfirm]);
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show,
      onConfirm: _onConfirm,
      confirmDisabled,
      confirmText: "Assign",
      onCancel: onClose,
      isLoading,
      title: "Select Status"
    },
    /* @__PURE__ */ React.createElement(StyledHelpBlock, null, "Please select the new status that should be assigned to all selected events."),
    isError ? /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, error.message) : null,
    /* @__PURE__ */ React.createElement(SelectContainer, null, /* @__PURE__ */ React.createElement(SetStatusControl, { width: "100%", onStatusChange: setNewStatus, value: newStatus }))
  );
};
const SetStatusBulk = ({ eventIds, onClose, show }) => {
  const { setStatus, settingStatus, isError, error } = useBulkSetStatusForSecurityEvents();
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const refetch = useRefetchTable();
  const deselectEntities = useDeselectEntities();
  const onConfirm = useCallback(
    async (status) => {
      try {
        await setStatus({ ids: eventIds, status });
        onClose();
        refetch();
        deselectEntities(eventIds);
        sendEventActionTelemetry("SET_STATUS", true);
      } catch (e) {
        console.log(e);
      }
    },
    [sendEventActionTelemetry, deselectEntities, eventIds, onClose, refetch, setStatus]
  );
  return show ? /* @__PURE__ */ React.createElement(
    SetStatusModal,
    {
      onConfirm,
      show: true,
      confirmDisabled: settingStatus,
      onClose,
      error,
      isError,
      isLoading: settingStatus
    }
  ) : null;
};
export default SetStatusBulk;
